import { Box, FontAwesomeIcon, Stack, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface DocumentDropOverlayProps {
  onDrop: (files: File[]) => void;
}

export const DocumentDropOverlay = ({ onDrop }: DocumentDropOverlayProps) => {
  const { t } = useTranslation();

  return (
    <div
      className="absolute -inset-6 z-10 flex items-center justify-center rounded-xs bg-light/80"
      onDrop={(e) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files).filter((f) => f.size > 0);
        if (files.length > 0) onDrop(files);
      }}
      onDragOver={(e) => e.preventDefault()}
    >
      <Box>
        <Stack items={"center"} gap={"sm"}>
          <div className="flex items-center justify-center rounded-xs h-9 w-9 bg-dark/5">
            <FontAwesomeIcon icon="fa-light fa-cloud-arrow-up" />
          </div>
          <Text className="text-center">{t("core:documents_drop_to_upload")}</Text>
        </Stack>
      </Box>
    </div>
  );
};
